import { causeItems } from "@/mocks/homeData";

const accentMap: Record<string, { chip: string; bar: string; num: string }> = {
  primary: {
    chip: "bg-primary-100 text-primary-800",
    bar: "bg-primary-500",
    num: "text-primary-600",
  },
  accent: {
    chip: "bg-accent-100 text-accent-800",
    bar: "bg-accent-500",
    num: "text-accent-600",
  },
  secondary: {
    chip: "bg-secondary-100 text-secondary-800",
    bar: "bg-secondary-500",
    num: "text-secondary-600",
  },
};

export default function Causes() {
  return (
    <section id="causes" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700 uppercase tracking-wider">
              <i className="ri-search-eye-line"></i>
              Causes
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              无法访问，通常卡在哪几个环节
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              一次访问要经过解析、连接、加载三个环节，任何一个环节出问题，结果都表现为「打不开」。
              把原因按环节拆开，就不会在同一个报错上反复打转，也更容易找到对应的解决办法。
            </p>

            <div className="mt-6 w-full h-56 md:h-64 rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20abstract%20illustration%20of%20glowing%20network%20nodes%20and%20connecting%20lines%20over%20a%20warm%20cream%20background%2C%20soft%20jade%20green%20and%20amber%20accents%2C%20clean%20editorial%20style%2C%20geometric%20composition%2C%20no%20text&width=1200&height=900&seq=causes-network-01&orientation=landscape"
                alt="抽象网络节点连线示意图，代表访问链路中的解析、连接与加载环节"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { k: "解析", v: "域名指向是否有效" },
                { k: "连接", v: "线路是否被拦截" },
                { k: "加载", v: "页面资源是否完整" },
              ].map((x) => (
                <div key={x.k} className="rounded-md bg-background-100 border border-background-200/70 px-3 py-2.5">
                  <p className="font-heading text-sm font-semibold text-foreground-900">{x.k}</p>
                  <p className="mt-1 text-[11px] text-foreground-500 leading-snug">{x.v}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <ul className="space-y-3">
              {causeItems.map((c, i) => {
                const a = accentMap[c.accent];
                return (
                  <li
                    key={c.title}
                    className="group rounded-lg bg-background-100 border border-background-200/80 p-5 md:p-6 flex gap-4 hover:bg-background-50 transition-colors"
                  >
                    <span className={`w-1 rounded-full ${a.bar} shrink-0`}></span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-3 flex-wrap">
                        <span className={`font-heading text-lg font-bold ${a.num}`}>
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className={`px-2.5 py-0.5 rounded-full text-[11px] font-medium ${a.chip}`}>
                          {c.tag}
                        </span>
                        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                          {c.title}
                        </h3>
                      </div>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}